module.exports = __webpack_public_path__ + "img/bahr_ios_802.png";